// extracted by mini-css-extract-plugin
export default {"start-virtual-visits":"start-virtual-visits_start-virtual-visits__jlL4i","text-message":"start-virtual-visits_text-message__BmeeV"};